import styled, {createGlobalStyle} from "styled-components";


export const Globalstyles = createGlobalStyle`
   
    
`

export const Image = styled.img`

    
`